import { render, staticRenderFns } from "./table-driver-distribution.vue?vue&type=template&id=8fe874e4&scoped=true&"
import script from "./table-driver-distribution.vue?vue&type=script&lang=js&"
export * from "./table-driver-distribution.vue?vue&type=script&lang=js&"
import style0 from "./table-driver-distribution.vue?vue&type=style&index=0&id=8fe874e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe874e4",
  null
  
)

export default component.exports